import { AppState, Platform } from "@-/com.npmjs.react-native";

export function subscribeStudyPresence(
  onPresence: (active: boolean) => void,
  _onActivity: () => void,
) {
  onPresence(AppState.currentState === "active");
  const subscription = AppState.addEventListener("change", (state) =>
    onPresence(state === "active"),
  );
  // Android's notification shade can blur the app without changing AppState.
  const blur =
    Platform.OS === "android"
      ? AppState.addEventListener("blur", () => onPresence(false))
      : undefined;
  const focus =
    Platform.OS === "android"
      ? AppState.addEventListener("focus", () => onPresence(AppState.currentState === "active"))
      : undefined;
  return () => {
    subscription.remove();
    blur?.remove();
    focus?.remove();
  };
}
